import {
  WorkflowAction,
  WorkflowStepDetails,
} from "modules/api/types/WorkflowPayload";

const hasSkippedPayment = (steps: WorkflowStepDetails): boolean =>
  steps.history.some((step) => step.action === WorkflowAction.SkipPayment);

export default hasSkippedPayment;
